export default {
    computed: {
        graphDateRangeLabel () {
            if (this.isChartDataEmpty) {
                return this.$t('BarGraph.no_data_completions')
            }
            if (!this.selectedYear) {
                return this.$t('BarGraph.select_last_twelve_months')
            } else {
                return this.selectedYear
            }
        },
        numberOfCompletedCourses () {
            return this.completedCourses.length
        },
        numberOfCompletedCoursesInYear () {
            let arrayOfDates = this.getYearlyArrayOfDatesInFormat('YYYY-MM', this.selectedYear)
            return this.completedCourses
                .filter(course => {
                    return arrayOfDates.includes(course.certificate.certificationDate.substring(0, 7))
                })
                .length
        },
        numberOfUnfinishedCoursesInYear () {
            let arrayOfDates = this.getYearlyArrayOfDatesInFormat('YYYY-MM', this.selectedYear)
            return this.unfinishedCourses
                .filter(course => {
                    return arrayOfDates.includes(course.lastActivityDateAndTime.substring(0, 7))
                })
                .length
        }
    }
}
